export default [
  { shop_id: "5e9412e0b2bfbc089daerr12", shop_name: "金水区店" },
  { shop_id: "5e9412e0b2bfbc089daerr18", shop_name: "郑东新区店" },
];
